import { component } from 'picoapp'
import $ from '../lib/quantdom'
import { centsToDollars, resizeImageSrc } from '../lib/utils'
import app from '../lib/pico-init'
export default component((node) => {
  $(node).on('click', async (e) => {
    const url = new URL(window.location)
    const handle = $(e.target).attr('data-handle')
    const id = $(e.target).attr('data-id')
    const firstVariantId = $(e.target).attr('data-first-variant-id')
    const productData = window.Flavors.find((el) => el.product.id == id)
    const { product, subscriptions, descriptions, amazonLink, retailer_logos } = productData
    const variant = product.variants.find((el) => el.id == firstVariantId)
    const option_index = product.options.findIndex((el) => el === 'Quantity')

    descriptions.forEach((el, i) => {
      $(`[aria-controls="details-mobile-${i}]>div`).html(el.title)
      $(`[aria-controls="details-${i}"]`).html(el.title)
      $(`#details-mobile-${i} .js-tab-content`).html(el.content)
      $(`#details-${i} .js-tab-content`).html(el.content)
    })
    var html = ``
    const any_available = product.variants.filter((v) => v.available === true)
    if (any_available.length > 0) {
      product.variants.forEach((el) => {
        if (el.available) {
          $('#main-add-to-cart').attr('data-sold-out', false)
          if (amazonLink) $('#amazon-add-to-cart').hide()
          $('#shop-pay-button').show()
          $('#frequency-button-container').attr('data-sold-out', false)
          html += `
        <button
          class="tw-text-sm tw-border js-size-btn aria-current:tw-border-[#FCB34C] tw-border-black tw-py-2 tw-px-14 aria-current:tw-bg-[#FCB34C33]/20 hover:tw-bg-[#F7F7F7]"
          data-component="sizeOptionSelector"
          data-option="${el.options[option_index]}"
          data-id="${product.id}"
          data-variant-id="${el.id}"
          aria-current="${el.id == firstVariantId ? true : false}"
        >
          ${el.options[option_index]}
        </button>`
        }
      })
    } else {
      html += '<h5>Sold Out</h5>'
      if (amazonLink) $('#amazon-add-to-cart').show()
      $('#shop-pay-button').hide()
      $('#main-add-to-cart').attr('data-sold-out', true)
      $('#frequency-button-container').attr('data-sold-out', true)
    }

    url.pathname = `/products/${handle}`
    url.searchParams.set('variant', firstVariantId)
    history.replaceState({}, '', url)

    let galleryImages = $('.js-product-image').els
    product.images.forEach((el, i) => {
      //If the gallery is longer than the product images, delete the extra nodes
      if (galleryImages.length > product.images.length && i == product.images.length - 1) {
        const difference = galleryImages.length - product.images.length
        for (let i = galleryImages.length - difference; i < galleryImages.length; i++) {
          $(galleryImages[i]).parent().els[0].remove()
        }
        galleryImages = $('.js-product-image').els
      }
      //If the gallery is shorter than the product images, add new nodes clones from the 2nd node
      else if (galleryImages.length < product.images.length && i < product.images.length - 1) {
        const parentNode = $(galleryImages[1]).parent().els[0]
        const clonedNode = parentNode.cloneNode(true)
        $('.js-product-gallery').els[0].append(clonedNode)
        galleryImages = $('.js-product-image').els
      }

      if (i == 0) {
        $(galleryImages[i]).parent().removeClass('tw-col-span-4').removeClass('tw-col-span-2').addClass('tw-col-span-3')
      } else if (galleryImages.length - 1 == i) {
        $(galleryImages[i]).parent().addClass('tw-col-span-4').removeClass('tw-col-span-2')
      } else if (galleryImages[i]) {
        $(galleryImages[i]).parent().removeClass('tw-col-span-4').addClass('tw-col-span-2')
      }

      if (galleryImages[i]) $(galleryImages[i]).attr('src', resizeImageSrc(el, 800))
    })
    $('.js-product-gallery').els[0].scrollLeft = 0

    const retailerLogos = retailer_logos || []
    const logoContainer = document.querySelector('.js-retailer-logos')

    if (logoContainer) {
      logoContainer.innerHTML = ''
      retailerLogos.forEach((logo, index) => {
        const img = document.createElement('img')
        img.setAttribute('src', resizeImageSrc(logo, 120))
        img.setAttribute('alt', `Retailer Logo ${index + 1}`)
        logoContainer.appendChild(img)
      })
    }

    $('.js-options').html(html)
    $('.js-product-price').text('$' + centsToDollars(variant.price, true))
    $('.js-one-time-price').text('$' + centsToDollars(variant.price, true))
    $('.js-pdp-afterpay').attr('data-amount', centsToDollars(variant.price))
    $('.js-purchase-type').attr('aria-current', false)
    $('.js-purchase-type[data-value="one-time"]').attr('aria-current', true).attr('data-price', variant.price)
    $('add-button#main-add-to-cart').attr('variant-id', firstVariantId)
    $('.dynamic-payment-button input[name="id"]').val(firstVariantId) //used for dynamic payment/buy now button
    $('.dynamic-payment-button').attr('aria-disabled', false) //used for dynamic payment/buy now button
    $('add-button#main-add-to-cart').attr('product-id', product.id)
    $('.js-product-id').attr('data-product-id', product.id)
    $('.js-product-nutrition').html(window.Flavors.filter((flavor) => flavor.product.id === product.id)[0].nutrition_facts)
    const addButton = $('add-button#main-add-to-cart').el()
    if (addButton) {
      addButton.removeAttribute('is-subscription')
    }
    $('.js-flavor-btn').attr('aria-current', false)
    $(e.target).attr('aria-current', true)

    if (subscriptions?.original_to_hidden_variant_map && subscriptions?.original_to_hidden_variant_map[firstVariantId]) {
      const subscriptionPrice = subscriptions?.original_to_hidden_variant_map[firstVariantId]?.discount_variant_price * 100
      $('.js-subscription-price').text('$' + centsToDollars(subscriptionPrice, true))
      $('.js-purchase-type[data-value="subscription"]').attr('aria-hidden', false).attr('data-price', subscriptionPrice)
    } else {
      $('.js-purchase-type[data-value="subscription"]').attr('aria-hidden', true)
    }
    $('.js-recommended-products').attr('data-product-id', product.id)
    $('.js-recommended-products').attr('data-component', 'recommendedProducts')
    $('.js-yotpo-main').attr('data-product-id', product.id)
    $('.js-yotpo-main').attr('data-component', 'yotpoMainReviews')
    $('.js-yotpo-stars').attr('data-product-id', product.id)
    $('.js-yotpo-stars').attr('data-component', 'yotpoStarRating')
    app.mount(['data-component'])

    window.MicroBus.emit('flavor:change', { product, firstVariantId, url, subscriptions })
  })
})
